import { SwitchTransition, CSSTransition } from "react-transition-group";
import { useRouter } from "next/router";
import { ReactNode, useRef } from "react";
import { useLenis } from "lenis/react";

interface PageTransitionProps {
  children: ReactNode;
}

const PageTransition = ({ children }: PageTransitionProps) => {
  const router = useRouter();
  const nodeRef = useRef<HTMLDivElement>(null);
  const lenis = useLenis();
  const pathOnly = router.asPath.split("?")[0];
  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={pathOnly}
        nodeRef={nodeRef}
        timeout={200}
        classNames="fade"
        unmountOnExit
        onExited={() => {
          if (lenis) {
            lenis.scrollTo(0, { immediate: true });
          }
        }}
      >
        <div ref={nodeRef} className="page-transition-wrapper">
          {children}
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
};

export default PageTransition;
